import React from 'react';
import ReactDOM from 'react-dom';
// import { SnackbarProvider, withSnackbar } from 'notistack';
import {useSnackbar } from "src/components/snackbar"

let useSnackbarRef;
export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar()
  return null
}


export default {
    success(msg, options = {}) {
        this.toast(msg, { horizontal: 'center', vertical: 'top',...options, variant: 'success' })
      },
      warning(msg, options = {}) {
        this.toast(msg, { horizontal: 'center', vertical: 'top', ...options, variant: 'warning' })
      },
      info(msg, options = {}) {
        this.toast(msg, {horizontal: 'center', vertical: 'top',  ...options, variant: 'info' })
      },
      error(msg, options = {}) {
        this.toast(msg, {horizontal: 'center', vertical: 'top', ...options, variant: 'error' })
      },
      toast(msg, options = {}) {
        useSnackbarRef.enqueueSnackbar(msg, options)
      }
};